<ng-select class="ad-select" bindLabel="description" bindValue="description" placeholder="Enter a location"
    id="google-add-{{id}}" [editableSearchTerm]="true" [formControl]="childFormControlName" [searchable]="true" [readonly]="readonly"
    [searchFn]="customSearchFn" (blur)="checkAddressDetails()" (search)="onInputChangePickup($event)"
    [items]="pickPlaces" (keyup)="lettersOnlyClick($event)" (change)="getPlaceDetails($event)"
    (input)="handleInput($event)" notFoundText="Type to select a location">
</ng-select>